<template>
  <aha-modal
    id="modal-request-limit"
    :title="modalLimitInfo.title"
    @hide="handleModalConfirm(false)"
  >
    <div class="text-base-90">
      {{ modalLimitInfo.body }}
    </div>

    <template #action>
      <aha-link
        v-if="modalLimitInfo.isReachedMaximum"
        @click="handleModalConfirm(false)"
      >
        <span class="font-bold">{{ $i18nPresenter.t('No, thanks') }}</span>
      </aha-link>
      <aha-button
        v-if="modalLimitInfo.isReachedMaximum"
        variant="primary"
        has-margin-left
        @click="handleModalConfirm(true)"
      >
        {{ $i18nPresenter.t('Get updates') }}
      </aha-button>
      <aha-button
        v-if="modalLimitInfo.isReachedThreshold"
        variant="primary"
        has-margin-left
        @click="handleModalConfirm(false)"
      >
        {{ $i18nPresenter.t('Okay') }}
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import eventCategories from '@/constant/eventCategories'
import utils from '@/util'
import OpenaiApi from '@/api/openai'

const REQUEST_MAXIMUM = 150
const REQUEST_THRESHOLD = 140

export default {
  computed: {
    ...mapState({
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      slideGenerator: (state) => state.slideGenerator,
    }),
    modalLimitInfo() {
      // slideGeneratorRequestCount >= REQUEST_MAXIMUM
      let title = "You've reached the beta access limit."
      let body = 'Thanks for using the beta version of the AI Quiz Generator! Get updates about the full release of this feature by clicking the button below.'
      const requestCount = (this.currentUser && this.currentUser.slideGeneratorRequestCount) || -1

      if (requestCount === REQUEST_THRESHOLD) {
        title = 'You have 10 uses left.'
        body = 'This beta version is limited to 150 uses. Use them wisely!'
      }

      return {
        isReachedThreshold: requestCount === REQUEST_THRESHOLD,
        isReachedMaximum: requestCount >= REQUEST_MAXIMUM,
        title,
        body,
      }
    },
  },
  methods: {
    ...mapActions(['setAIRequestLimitModalStateAction']),
    async handleModalConfirm(confirm = false) {
      if (confirm) {
        await OpenaiApi.requestMoreQuiz({
          plan: this.$store.state.plan,
        })
        utils.showToastSuccess(this.$i18nPresenter.t("Thanks! We'll update you via email."))
        utils.mixpanelTracking(
          eventCategories.PRESENTATION_EDITOR,
          'AI Quiz Generator > Over limit > Send request',
          null,
          null,
          {
            presentationId: this.presentation.id,
          },
        )
      }
      this.setAIRequestLimitModalStateAction(false)
    },
  },
}
</script>
